/**
 * Copyright (c) HashiCorp, Inc.
 */

import { HdsIcon } from '@hashicorp/design-system-components/components';

import type { TOC } from '@ember/component/template-only';
import type { HdsIconSignature } from '@hashicorp/design-system-components/components/hds/icon/index';

import './text-with-icon.scss';

export interface CutTextWithIconSignature {
  Args: {
    icon: HdsIconSignature['Args']['name'];
    text: string;
    connection?: string;
    iconColor?: HdsIconSignature['Args']['color'];
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const CutTextWithIcon: TOC<CutTextWithIconSignature> = <template>
  <div
    class="cut-text-with-icon hds-typography-body-100 hds-font-weight-regular"
    ...attributes
  >
    <HdsIcon @name={{@icon}} @color={{@iconColor}} />
    <div>{{@text}}</div>
    {{#if @connection}}
      <div class="cut-text-with-icon__connection">{{@connection}}</div>
    {{/if}}
  </div>
</template>;

export default CutTextWithIcon;
